import { LoadState } from "../../../constants/enums";

export interface ILeadApplication {
  id: number;
  type: string;
  line_of_business: string;
  lead_id: string;
  customer_id: number | null;
  customer_policy_id: number | null;
  incremental_number: number;
  applicant_name: string | null;
  applicant_address: string | null;
  applicant_address_two: string | null;
  applicant_city: string | null;
  applicant_province_or_state: string | null;
  applicant_postal_code: string | null;
  applicant_country: string | null;
  policy_number: string;
  effective_date: string | null;
  expiry_date: string | null;
  billing_method: string | null;
  type_of_payment_plan: string | null;
  status: string;
  insert_ts: string | null;
  sub_type: string | null;
}

export interface ILeadApplicationsState {
  list: ILeadApplication[];
  totalRecords: number;
  loading: LoadState;
}

export const initialLeadApplicationsState: ILeadApplicationsState = {
  list: [],
  totalRecords: 0,
  loading: LoadState.NotLoaded,
};
